(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery_grid_home_candy"] && !Shopify.designMode) return;
  try {
    
// No JS needed for static gallery.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
/* --- Auto-fit Testimonial Section Height --- */
document.addEventListener('DOMContentLoaded', () => {
  const testimonialSection = document.querySelector('.testimonials-section');
  const flickityViewport = testimonialSection?.querySelector('.flickity-viewport');
  if (!testimonialSection || !flickityViewport) return;

  const slides = testimonialSection.querySelectorAll('.testimonials-slide');
  let tallest = 0;

  slides.forEach(slide => {
    const h = slide.scrollHeight;
    if (h > tallest) tallest = h;
  });

  if (tallest > 0) {
    flickityViewport.style.minHeight = `${tallest}px`;
  }

  // Re-measure when window resizes (mobile landscape, etc.)
  window.addEventListener('resize', () => {
    let maxH = 0;
    slides.forEach(slide => {
      const h = slide.scrollHeight;
      if (h > maxH) maxH = h;
    });
    flickityViewport.style.minHeight = `${maxH}px`;
  });
});

  } catch(e) { console.error(e); }
})();
})();
